import styled from 'styled-components';
import { iPadDown } from '../../../styles/mediaQueries';
import { ButtonOptions, ButtonSizes } from '../types';

type SuccessIconProps = Pick<ButtonOptions, 'size'>;

const successIconSizes: Record<ButtonSizes, string> = {
  small: `
        height: 0.76vw;

        ${iPadDown} {
            height: 2.34vw;
        }
    `,

  medium: `
        height: 0.98vw;

        ${iPadDown} {
            height: 2.85vw;
        }
    `,

  large: `
        height: 0.98vw;

        ${iPadDown} {
            height: 2.85vw;
        }
    `,
};

const SuccessIcon = styled.svg<SuccessIconProps>`
  width: auto;
  ${({ size = 'large' }) => successIconSizes[size]}

  path {
    fill: currentColor;
    stroke: currentColor;
  }
`;

export default SuccessIcon;
